/*
 * @Author: Suroc
 * @Date: 2024-06-12 09:44:21
 * @LastEditTime: 2024-11-18 20:31:26
 * @Description: 路由
 */
export default [
  {
    path: "/",
    redirect: "/download",
  },
  {
    path: "/download",
    component: () => import("@/pages/download.vue"),
  },
];
